import { LocationState, RootState, Location, Site } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import LocationService from '@/services/location.service';

type LocationGetter = GetterTree<LocationState, RootState>;

export const initialState = (): LocationState => {
  return {
    initialState,
    locations: [],
    total: 0,
  };
};

export const getters: LocationGetter = {
  locations: (state) => state.locations,
  locationsForSite: (state) => (siteId: number) => state.locations.filter((item: Location) => item.site_id === siteId),
  getLocationById: (state) => (id: number) => state.locations.find((item: Location) => item.id === id),
};

export const mutations: MutationTree<LocationState> = {
  addLocations(state, newLocations) {
    state.total = newLocations.total;
    state.locations = newLocations.locations;
  },
  addLocation(state, newLocation) {
    state.total = state.total++;
    state.locations.push(newLocation);
  },
  updateLocation(state, uLocation: Location) {
    state.locations[state.locations.findIndex((location: Location) => location.id === uLocation.id)] = uLocation;
  },
  deleteLocation(state, dLocation: Location) {
    state.locations.splice(state.locations.findIndex((location: Location) => location.id === dLocation.id));
  },
};

export const actions: ActionTree<LocationState, RootState> = {
  async addLocationsAsync(context) {
    const response = await LocationService.getLocations();
    context.commit('addLocations', response.locations);
    return response.locations;
  },
  async createLocationAsync(context, location) {
    const newLocation = await LocationService.createLocation(location);
    context.commit('addLocation', newLocation);
    return newLocation;
  },
  async updateLocationAsync(context: any, location: {
    project_id: number,
    site_id: number,
    id: number,
    payload: object,
  }) {
    const updatedLocation = await LocationService.updateLocation(
      location.project_id, location.site_id, location.id, location.payload,
    );
    context.commit('updateLocation', updatedLocation);
    return updatedLocation;
  },
  async deleteLocationAsync(context: any, location: {
    project_id: number,
    site_id: number,
    id: number,
  }) {
    const response = await LocationService.deleteLocation(
      location.project_id, location.site_id, location.id,
    );
    context.commit('deleteLocation', response);
    return response;
  },
};


export const locations: Module<LocationState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
